module.exports = __webpack_public_path__ + "static/media/mail.f61884bd.svg";